import type { ContentfulInformationBox } from "../../../common/types/cmsTypes";
import RichTextRenderer from "../../cms/RichTextRenderer";
import InformationBox from "./InformationBox";

type CmsInformationBoxProps = {
   content: ContentfulInformationBox;
};
const CmsInformationBox = ({ content }: CmsInformationBoxProps) => {
   const { fields } = content;
   const { theme, title, body } = fields;
   const informationBoxTheme = theme === "Bærekraft" ? "sustainable" : "main";

   return (
      <InformationBox theme={informationBoxTheme} title={title} className="tw-mt-6">
         {body && (
            <RichTextRenderer
               document={body}
               variant="informationBox"
               context="information-box"
               trackingLocationName="Information box"
            />
         )}
      </InformationBox>
   );
};

export default CmsInformationBox;
